export { default } from './AdsBannerSkeleton';